<!-- <a href="#" target="_blank" class="logo"></a> -->
<div class="logo">
  <img src="assets/img/RedThread_Clear_Registered.png" alt="" class="logo-img">
</div>

